import { render } from "./withdrawDeposit.vue?vue&type=template&id=80b87fb6&scoped=true&ts=true"
import script from "./withdrawDeposit.vue?vue&type=script&lang=ts"
export * from "./withdrawDeposit.vue?vue&type=script&lang=ts"

import "./withdrawDeposit.vue?vue&type=style&index=0&id=80b87fb6&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b87fb6"]])

export default __exports__